import axios from '@/lib/axios';
import store from '@/store/index';

function findByBounds() {
  const params = {
    ...store.getters.mapBounds,
  };

  return axios
    .get('/places/bounds', {
      params,
    })
    .then((response) => response.data.items);
}

function findById(id) {
  return axios.get(`/places/${id}`).then((response) => response.data.place);
}

function create(formData) {
  return axios.post('/places/create', formData).then((response) => response.data.place);
}

export default { findByBounds, findById, create };
